module.exports = __webpack_public_path__ + "static/media/git.e4b384ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/git.png
// module id = 53
// module chunks = 0